/* eslint-disable no-unused-vars */
import Icon, { ImportOutlined, RedoOutlined } from "@ant-design/icons";
import { Col, Input, Layout, Modal, Row, Spin, Tooltip } from "antd";
import React, { useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import { ReactComponent as BellIcon } from "@assets/images/svg/notification.svg";
import { ReactComponent as Tasks } from "@assets/images/svg/task.svg";
import { ReactComponent as Training } from "@assets/images/svg/training-white.svg";
import GlobalSearchModal from "@app/widgets/global-search";
import Tickets from "@ui/tasks";
import { refreshMetaCache } from "@redux/actionCreators";
import Reminders from "@app/widgets/reminders";
import { DraggableTitle, DraggableWrapper } from "@ui/modals/draggable-wrapper";

import Auth from "config/auth";

import DropDownMenu from "./drop-down-menu";
import HeaderMenu from "./header-menu";

import "./styles.scss";
import { Search } from "@ui/form-controls/search";

const { Header } = Layout;
const iconProps = { style: { color: "#fff" } };
const authData = Auth.getSessionDetails();
const { currentUserRole } = authData;

const HeaderComponent = () => {
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [activePage, setActivePage] = useState(null);
  const [searchString, setSearchString] = useState("");
  const metaData = useSelector(state => state.driverReducer, shallowEqual);
  const reducerData = useSelector(state => state.siteFilter, shallowEqual);
  const { currentUserRoleData } = reducerData;
  const {
    refreshMetaCacheInfo: { isLoading }
  } = metaData;
  const [successModal, setSuccessModal] = useState(false);
  const userData = JSON.parse(localStorage.getItem("loggedInUser"));

  const closeModal = () => {
    setSearchString("");
    setIsModalVisible(false);
  };

  const refreshMetaData = () => {
    dispatch(refreshMetaCache());
    setSuccessModal(true);
  };

  const curRole = currentUserRoleData || currentUserRole;
  const assignedFlag = true;
  const TRUE = true;

  const handleClearSearch = () => {
    setSearchString("");
  };

  return (
    <Header className="main-header">
      <Modal
        title={<DraggableTitle title={"Success"} />}
        modalRender={modal => <DraggableWrapper>{modal}</DraggableWrapper>}
        open={successModal}
        footer={null}
        onCancel={() => setSuccessModal(false)}
        maskClosable={TRUE}
        width="400px"
        centered
        destroyOnClose
        className="drs-modal-css"
      >
        <div>
          {!isLoading ? (
            <p>Successfully refreshed meta cache information.</p>
          ) : (
            <div style={{ textAlign: "center" }}>
              <Spin />
            </div>
          )}
        </div>
      </Modal>

      <Row align="middle" style={{ lineHeight: "40px" }}>
        <Col>
          <DropDownMenu />
        </Col>

        <Col xs={6} sm={6} md={2} lg={7} xl={7}>
          <div className="logo" style={{ marginLeft: "1rem" }}>
            {userData?.subscriberName || "DRS"}
          </div>
        </Col>

        <Col xs={0} sm={0} md={9} lg={8} xl={8}>
          <Row className="mt-1">
            <Search
              placeholder="Search"
              onSearch={() => {
                setIsModalVisible(true);
                setActivePage("Search");
              }}
              onChange={event => {
                setSearchString(event.target.value);
              }}
              disabled={curRole === "Client" || curRole === "System Admin"}
              value={searchString}
            />
          </Row>
        </Col>

        <Col xs={16} sm={16} md={12} lg={8} xl={8}>
          <div className="settings-part" style={{ marginRight: "-4rem" }}>
            <Tooltip title="Training">
              <Icon
                component={Training}
                className="iconSize"
                style={{ color: "#fff" }}
                onClick={() => {
                  window.location.href = "https://www.driverrecruitmentsoftware.com/courses/";
                }}
              />
            </Tooltip>
            <Tooltip title="Tickets assigned to me">
              <Icon
                component={Tasks}
                className="iconSize"
                style={{ color: "#fff" }}
                onClick={() => {
                  setIsModalVisible(true);
                  setActivePage("Tickets");
                }}
              />
            </Tooltip>
            <Tooltip title="Reminders">
              <Icon
                component={BellIcon}
                className="iconSize"
                onClick={() => {
                  setIsModalVisible(true);
                  setActivePage("Reminders");
                }}
              />
            </Tooltip>
            <Tooltip title="Refresh Meta Cache">
              <RedoOutlined {...iconProps} onClick={refreshMetaData} className="iconSize" />
            </Tooltip>
            <HeaderMenu />
          </div>
        </Col>
      </Row>

      {activePage === "Search" && (
        <GlobalSearchModal
          isVisible={isModalVisible}
          resetModalFn={closeModal}
          width="80%"
          modalHeader="Search Results"
          searchString={searchString}
        />
      )}

      <Modal
        title={<DraggableTitle title={activePage} />}
        modalRender={modal => <DraggableWrapper>{modal}</DraggableWrapper>}
        open={isModalVisible && activePage !== "Search"}
        onCancel={() => {
          closeModal();
          handleClearSearch();
        }}
        width="90%"
        destroyOnClose
        centered
        footer=""
        className="drs-modal-css"
        bodyStyle={{ maxHeight: "550px", overflow: "scroll" }}
      >
        {activePage === "Reminders" && <Reminders loggedUser={userData} />}
        {activePage === "Tickets" && (
          <Tickets
            loggedUser={userData}
            isModalVisible={isModalVisible}
            assignTickets={assignedFlag}
            disableDelete="Yes"
          />
        )}
      </Modal>
    </Header>
  );
};

export default React.memo(HeaderComponent);
